import type { ClientOrgInvite } from './clientOrganization';

export const CLIENT_ORG_INVITE_CREATED_EVENT = 'client-org:invite-created';

export type ClientOrgInviteCreatedEventDetail = {
  invite: ClientOrgInvite;
};
